import axios from 'axios';

import { HTTP_STATUS } from '@/shared/lib/constants/api';

import { ASSET_TYPE_PLURALS } from './constants';

export const getEntityEndpoint = (entityType: string): string => {
  const typeMap: Record<string, string> = {
    table: ASSET_TYPE_PLURALS.TABLE,
    database: ASSET_TYPE_PLURALS.DATABASE,
    databaseSchema: ASSET_TYPE_PLURALS.DATABASE_SCHEMA,
    container: ASSET_TYPE_PLURALS.CONTAINER,
    topic: ASSET_TYPE_PLURALS.TOPIC,
    dashboard: 'dashboards',
    pipeline: 'pipelines',
    mlmodel: 'mlmodels',
    glossaryTerm: ASSET_TYPE_PLURALS.GLOSSARY_TERM,
    tag: ASSET_TYPE_PLURALS.TAG,
  };

  return typeMap[entityType] || `${entityType}s`;
};

export const handleApiError = (error: unknown, context: string): never => {
  console.error(`Failed to ${context}:`, error);

  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    const message = error.response?.data?.message || error.message;

    if (status === HTTP_STATUS.UNAUTHORIZED) {
      throw new Error('인증이 필요합니다. 다시 로그인해주세요.');
    } else if (status === HTTP_STATUS.FORBIDDEN) {
      throw new Error('접근 권한이 없습니다.');
    } else if (status && status >= HTTP_STATUS.INTERNAL_SERVER_ERROR) {
      throw new Error('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } else {
      throw new Error(`API Error: ${message}`);
    }
  }

  throw new Error('알 수 없는 오류가 발생했습니다.');
};

export const extractTagName = (tagFQN: string): string => {
  const parts = tagFQN.split('.');
  return parts[parts.length - 1];
};
